module.exports = __webpack_public_path__ + "static/Ambiado-15aaa0c1e491a46348d066437d1ce3c6.mp4";